import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const userState = useSelector((state) => state.userState);
  const { userInfo } = userState;

  return userInfo && userInfo?.role == "ROLE_ADMIN" ? (
    <Outlet />
  ) : userInfo && (userInfo?.role == "ROLE_MERCHANT" || "ROLE_SUPER_ADMIN") ? (
    <Navigate to={{ pathname: "/unauthorized" }} />
  ) : (
    <Navigate to={{ pathname: "/login" }} />
  );
};

export default PrivateRoute;
